<ng-container [ngSwitch]="restaurant?.screenType">
  <!-- Opción 1: Botones personalizados (default) -->
  <ng-container *ngSwitchCase="TYPES_SCREEN.buttons">
    <div *ngIf="restaurant.logo && restaurant.services !== 'X'" [ngStyle]="{'background': restaurant?.color}" class="h-100 overflow-auto">
      <ng-container *ngIf="viewMenuOptions()">
        <div class="position-absolute mt-2 mr-2 buttonClose animate__animated animate__delay-2s bounceIn" *ngIf="isShowBranchesButtons">
          <button class="btn btn-icon" [ngStyle]="{'background':restaurant?.color,'color': colorText}" type="button" (click)="isShowBranchesButtons = false">
            <i class="fas fa-arrow-left m--1"></i>
          </button>
        </div>
        <!-- Logo del restaurante -->
        <header>
          <div class="row d-flex justify-content-center animate__animated animate__delay-1s fadeIn imgHeader">
            <img [src]="restaurant?.logo" alt="logo" class="logo img-fluid">
          </div>
        </header>
        <!-- Botones de acceso a sucursales asociadas al restaurante -->
        <ng-container [ngTemplateOutlet]="sucursalButtons" *ngIf="false && restaurant.branches && !isShowBranchesButtons">
        </ng-container>
        <!-- Botones genericos de acceso a menus -->
        <ng-container [ngTemplateOutlet]="normalButtons" *ngIf="(!restaurant.branches || isShowBranchesButtons) && (!restaurant.bigButtons)">
        </ng-container>
        <!-- Botones grandes de acceso a menus -->
        <ng-container [ngTemplateOutlet]="bigButtons" *ngIf="(!restaurant.branches || isShowBranchesButtons) && (restaurant.bigButtons)">
        </ng-container>
        <!-- <Pide de pagina con las redes sociales -->
        <div class="animate__animated fadeIn animate__delay-1s bottom-0 w-100" *ngIf="restaurant.instagram">
          <app-footer [restaurant]="restaurant" [showForm]="false"></app-footer>
        </div>
      </ng-container>
      <!-- Pagina de home -->
      <app-home *ngIf="viewHome()"></app-home>
    </div>
  </ng-container>

  <!-- Opción 2: Pantalla completa con botones de texto -->
  <ng-container *ngSwitchCase="TYPES_SCREEN.fullScreen">
    <div [ngStyle]="{'background': restaurant?.color}" class="h-100 overflow-auto" *ngIf="viewMenuOptions()">
      <ng-container [ngTemplateOutlet]="backgroundPage"></ng-container>
    </div>
    <!-- Pagina de home -->
    <app-home *ngIf="viewHome()"></app-home>
  </ng-container>

  <!-- Opción 3: Pantalla completa con botones de imagen -->
  <ng-container *ngSwitchCase="TYPES_SCREEN.fullScreenButtons">
    <div [ngStyle]="{'background': restaurant?.color}" class="h-100 overflow-auto" *ngIf="viewMenuOptions()">

      <ng-container [ngTemplateOutlet]="backgroundWithButtons"></ng-container>
    </div>
    <!-- Pagina de home -->
    <app-home *ngIf="viewHome()"></app-home>
  </ng-container>

  <!-- Default: Si no existe screenType, se muestra como buttons -->
  <ng-container *ngSwitchDefault>
    <div *ngIf="restaurant.logo && restaurant.services !== 'X'" [ngStyle]="{'background': restaurant?.color}" class="h-100 overflow-auto">
      <ng-container *ngIf="viewMenuOptions()">
        <div class="position-absolute mt-2 mr-2 buttonClose animate__animated animate__delay-2s bounceIn" *ngIf="isShowBranchesButtons">
          <button class="btn btn-icon" [ngStyle]="{'background':restaurant?.color,'color': colorText}" type="button" (click)="isShowBranchesButtons = false">
            <i class="fas fa-arrow-left m--1"></i>
          </button>
        </div>
        <!-- Logo del restaurante -->
        <header>
          <div class="row d-flex justify-content-center animate__animated animate__delay-1s fadeIn imgHeader">
            <img [src]="restaurant?.logo" alt="logo" class="logo img-fluid">
          </div>
        </header>
        <!-- Botones de acceso a sucursales asociadas al restaurante -->
        <ng-container [ngTemplateOutlet]="sucursalButtons" *ngIf="false && restaurant.branches && !isShowBranchesButtons">
        </ng-container>
        <!-- Botones genericos de acceso a menus -->
        <ng-container [ngTemplateOutlet]="normalButtons" *ngIf="(!restaurant.branches || isShowBranchesButtons) && (!restaurant.bigButtons)">
        </ng-container>
        <!-- Botones grandes de acceso a menus -->
        <ng-container [ngTemplateOutlet]="bigButtons" *ngIf="(!restaurant.branches || isShowBranchesButtons) && (restaurant.bigButtons)">
        </ng-container>
        <!-- <Pide de pagina con las redes sociales -->
        <div class="animate__animated fadeIn animate__delay-1s bottom-0 w-100" *ngIf="restaurant.instagram">
          <app-footer [restaurant]="restaurant" [showForm]="false"></app-footer>
        </div>
      </ng-container>
      <!-- Pagina de home -->
      <app-home *ngIf="viewHome()"></app-home>
    </div>
  </ng-container>
</ng-container>

<ng-template #backgroundPage>
  <div *ngIf="restaurant.logo && restaurant.services !== 'X'" [ngStyle]="{'background-image':' url(' + restaurant.imgBackground + ')'}"
    class="backgroundPage-container animate__animated animate__delay-1s fadeIn">
    <div class="backgroundPage-buttons row mt-6">
      <!-- Botón 1: Comida -->
      <div
        *ngIf="restaurant.menuType === 'twoMenu' || restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'"
        class="col backgroundPage-button {{restaurant.fontHeader}}"
        [ngStyle]="{'color': restaurant.colorText, 'background': restaurant.color, 'border-color': restaurant.colorText}" (click)="openMenu('cocina')">
        {{ menuService.getLabelMenu(restaurant.labelFoodMenu ? restaurant.labelFoodMenu : 'Comida') || 'Comida' }}
      </div>

      <!-- Botón 2: Bebidas / Bar -->
      <div
        *ngIf="restaurant.menuType === 'twoMenu' || restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'"
        class="col backgroundPage-button {{restaurant.fontHeader}}"
        [ngStyle]="{'color': restaurant.colorText, 'background': restaurant.color, 'border-color': restaurant.colorText}" (click)="openMenu('bar')">
        {{ menuService.getLabelMenu(restaurant.labelBarMenu ? restaurant.labelBarMenu : 'BEBIDAS') || 'Bebidas' }}
      </div>

      <!-- Botón 3: Brunch (solo para threeMenu / fourMenu) -->
      <div *ngIf="restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'"
        class="col backgroundPage-button {{restaurant.fontHeader}}"
        [ngStyle]="{'color': restaurant.colorText, 'background': restaurant.color, 'border-color': restaurant.colorText}" (click)="openMenu('brunch')">
        {{ menuService.getLabelMenu(restaurant.labelBrunch ? restaurant.labelBrunch : 'Brunch') || 'Brunch' }}
      </div>

      <!-- Botón 4: Extra / Cuarto menú (solo para fourMenu) -->
      <div *ngIf="restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'" class="col backgroundPage-button {{restaurant.fontHeader}}"
        [ngStyle]="{'color': restaurant.colorText, 'background': restaurant.color, 'border-color': restaurant.colorText}" (click)="openMenu('extra')">
        {{ menuService.getLabelMenu(restaurant.fourMenu ? restaurant.fourMenu : 'Extra') || 'Extra' }}
      </div>
      <!-- Slogan debajo de los botones (si existe) -->
      <div class="row d-flex justify-content-center text-center w-100 {{restaurant.fontHeader}} animate__animated animate__delay-1s fadeIn" *ngIf="restaurant.slogan">
        <p class="mt-1 slogan" [ngStyle]="{'color': restaurant.colorText}">{{ restaurant.slogan }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #normalButtons>
  <div class="buttons" [ngStyle]="{'background': restaurant?.color}">
    <div class="buttons-container row w-100 pl-4 pr-4 pt-2 justify-content-center mr-0 ml-0 animate__animated animate__delay-1s fadeIn">
      <!-- Boton de bebidas first-->
      <div *ngIf="restaurant.drinksFirst" class="col-12 d-flex button col-xl-10 mb-2" [ngClass]="{'button-height': setHeightButton()}"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgDrinks + ')'}" (click)="openMenu('bar')">
      </div>
      <!-- Boton de comida -->
      <div class="col-12 d-flex button col-xl-10 mb-2" [ngClass]="{'button-height': setHeightButton()}" [ngStyle]="{'background-image':' url(' + restaurant?.imgFood + ')'}"
        (click)="openMenu('cocina')">
      </div>
      <!-- Boton de brunch -->
      <div class="col-12 d-flex button mb-2 col-xl-10"
        *ngIf="((restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu')) && !restaurant.brunchOff"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgBrunch + ')'}" (click)="openMenu('brunch')">
      </div>
      <!-- Boton de bebidas -->
      <div *ngIf="!restaurant.drinksFirst" class="col-12 d-flex button col-xl-10 mb-2" [ngClass]="{'button-height': setHeightButton()}"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgDrinks + ')'}" (click)="openMenu('bar')">
      </div>

      <!-- Boton de extra -->
      <div class="col-12 d-flex button mb-2 col-xl-10 mb-2" *ngIf="restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgExtra + ')'}" (click)="openMenu('extra')">
      </div>
      <!-- Frase de slogan del restaurante -->
      <div class="row d-flex justify-content-center text-center w-100 {{restaurant.fontHeader}} animate__animated animate__delay-1s fadeIn" *ngIf="restaurant.slogan">
        <p class="mt-1 slogan" [ngStyle]="{'color': colorText}" [innerHTML]="restaurant?.slogan"></p>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #bigButtons>
  <div class="animate__animated animate__delay-1s fadeIn bigbuttons--overflow">
    <div class="row d-flex justify-content-center p-2" *ngIf="restaurant.drinksFirst">
      <div class="col-11">
        <img [src]="restaurant.imgDrinks" alt="" (click)="openMenu('bar')" class="img-fluid rounded">
      </div>
    </div>
    <div class="row d-flex justify-content-center p-2">
      <div class="col-11">
        <img [src]="restaurant.imgFood" alt="" (click)="openMenu('cocina')" class="img-fluid rounded">
      </div>
    </div>
    <div class="row d-flex justify-content-center p-2" *ngIf="!restaurant.drinksFirst">
      <div class="col-11">
        <img [src]="restaurant.imgDrinks" alt="" (click)="openMenu('bar')" class="img-fluid rounded">
      </div>
    </div>
    <div class="row d-flex justify-content-center p-2"
      *ngIf="(restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu') && !restaurant.brunchOff">
      <div class="col-11">
        <img [src]="restaurant.imgBrunch" alt="" (click)="openMenu('brunch')" class="img-fluid rounded">
      </div>
    </div>
    <div class="row d-flex justify-content-center p-2" *ngIf="restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'">
      <div class="col-11">
        <img [src]="restaurant.imgExtra" alt="" (click)="openMenu('extra')" class="img-fluid rounded">
      </div>
    </div>
    <!-- Frase de slogan del restaurante -->
    <div class="row d-flex justify-content-center text-center {{restaurant.fontHeader}} animate__animated animate__delay-1s fadeIn" *ngIf="restaurant.slogan">
      <p class="mt-3 slogan" [ngStyle]="{'color': colorText}">{{ restaurant?.slogan }}</p>
    </div>
  </div>
</ng-template>


<ng-template #backgroundWithButtons>
  <div *ngIf="restaurant.logo && restaurant.services !== 'X'" [ngStyle]="{'background-image':' url(' + restaurant.imgBackground + ')'}"
    class="backgroundPage-container animate__animated animate__delay-1s fadeIn">
    <div class="buttons-container row w-100 pl-4 pr-4 pt-2 justify-content-center mr-0 ml-0 mt-6">
      <!-- Boton de bebidas first-->
      <div *ngIf="restaurant.drinksFirst" class="col-12 d-flex button button-fullscreen col-xl-10 mb-2" [ngStyle]="{'background-image':' url(' + restaurant?.imgDrinks + ')'}"
        (click)="openMenu('bar')">
      </div>
      <!-- Boton de comida -->
      <div class="col-12 d-flex  button-fullscreen col-xl-10 mb-2" [ngStyle]="{'background-image':' url(' + restaurant?.imgFood + ')'}" (click)="openMenu('cocina')">
      </div>
      <!-- Boton de brunch -->
      <div class="col-12 d-flex  button-fullscreen mb-2 col-xl-10"
        *ngIf="((restaurant.menuType === 'threeMenu' || restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu')) && !restaurant.brunchOff"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgBrunch + ')'}" (click)="openMenu('brunch')">
      </div>
      <!-- Boton de bebidas -->
      <div *ngIf="!restaurant.drinksFirst" class="col-12 d-flex  button-fullscreen col-xl-10 mb-2" [ngStyle]="{'background-image':' url(' + restaurant?.imgDrinks + ')'}"
        (click)="openMenu('bar')">
      </div>

      <!-- Boton de extra -->
      <div class="col-12 d-flex button-fullscreen mb-2 col-xl-10" *ngIf="restaurant.menuType === 'fourMenu' || restaurant.menuType === 'fourMenuWithOutSideMenu'"
        [ngStyle]="{'background-image':' url(' + restaurant?.imgExtra + ')'}" (click)="openMenu('extra')">
      </div>
      <!-- Frase de slogan del restaurante -->
      <div class="row d-flex justify-content-center text-center w-100 {{restaurant.fontHeader}} animate__animated animate__delay-1s fadeIn" *ngIf="restaurant.slogan">
        <p class="mt-1 slogan" [ngStyle]="{'color': colorText}">{{ restaurant?.slogan }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #sucursalButtons>
  <div class="row d-flex justify-content-center mt-5 animate__animated animate__delay-1s fadeIn">
    <div class="row w-100 d-flex justify-content-center mb-3">
      <div class="col-10 d-flex justify-content-center backgroundPage-button {{restaurant.fontHeader}}" (click)="isShowBranchesButtons = true"
        [ngStyle]="{'color': colorText, 'background': restaurant.color, 'border-color': colorText}">
        {{restaurant.name | titlecase}}
      </div>
    </div>
    <div class="row w-100 d-flex justify-content-center" *ngFor="let branch of restaurant.branches">
      <div class="col-10 d-flex justify-content-center backgroundPage-button {{restaurant.fontHeader}}" (click)="navigateToMenu(branch.id)"
        [ngStyle]="{'color': colorText, 'background': restaurant.color, 'border-color': colorText}">
        {{branch.name | titlecase}}
      </div>
    </div>
  </div>
</ng-template>